export enum TransactionsModal {
  HOW_IT_WORKS,
  STATUS,
  REVERSE_TRANSACTIONS,
}
